/* VD Card Cart — Temu-style compact add-to-cart on product cards.
 *
 * NO Liquid card edits required: this script scans rendered product cards and
 * injects one compact circular icon button into each card's image area.
 *
 * The icon is a REAL <button> with its own click handler. It does NOT rely on
 * proxy-clicking a display:none element (that was the previous bug — the
 * theme's add/choose controls live inside `.product-card-addtocart.hidden`,
 * which is `display:none !important`, so element.click() on the submit button
 * never triggered the form's submit handler).
 *
 * Behaviour (driven by the card's own rendered controls):
 *  - Single purchasable variant : we read the variant id straight from the
 *      card's <product-form> hidden `input[name="id"]` and POST it ourselves to
 *      /cart/add.js (Shopify AJAX cart). We then drive the theme's OWN cart UI
 *      (cart-drawer or cart-notification renderContents) to open the drawer /
 *      notification and refresh the header count bubble, exactly like the theme
 *      does on its native add. Plus a fly-to-cart animation.
 *  - Multiple variants          : we open a self-contained on-page quick-add
 *      popup (see the Quick-Add module below) that lets the shopper pick each
 *      option and add the resolved variant without leaving the page.
 *      We never add a guessed variant.
 *  - Sold out                   : disabled, no action.
 *
 * Works on collection, search, featured, and related-product cards, and on
 * cards injected later (infinite scroll / AJAX) via a MutationObserver.
 */
(function () {
  'use strict';
  if (window.__vdCardCartInit) return;
  window.__vdCardCartInit = true;

  var SVG_CART =
    '<svg class="vd-cart-glyph" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<circle cx="9" cy="20" r="1.4"></circle><circle cx="17" cy="20" r="1.4"></circle>' +
    '<path d="M2.5 3h2l2.2 11.2a1.6 1.6 0 0 0 1.6 1.3h7.9a1.6 1.6 0 0 0 1.6-1.2l1.3-6.3H6"></path>' +
    '<line x1="15.5" y1="6" x2="21.5" y2="6"></line><line x1="18.5" y1="3" x2="18.5" y2="9"></line></svg>';
  var SVG_SPIN =
    '<svg class="vd-cart-spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 3a9 9 0 1 0 9 9"></path></svg>';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cartIcon() {
    return document.getElementById('cart-icon-bubble') ||
           document.querySelector('.header__icon--cart') ||
           document.querySelector('a[href$="/cart"]');
  }

  /* The theme's own AJAX cart UI element (drawer or notification). */
  function cartUI() {
    return document.querySelector('cart-notification') ||
           document.querySelector('cart-drawer');
  }

  /* The variant id for a single-variant add — read from the card's own form. */
  function findVariantId(card) {
    var input = card.querySelector('product-form input[name="id"]');
    if (input && input.value) return input.value;
    return null;
  }
  /* The theme's own add-to-cart submit (single-variant cards). */
  function findAddSubmit(card) {
    return card.querySelector('product-form button[name="add"]') ||
           card.querySelector('product-form [type="submit"]') ||
           card.querySelector('.quick-add__submit');
  }
  /* The theme's own choose/select-options trigger (multi-variant cards). */
  function findChooseOptions(card) {
    return card.querySelector('.product-chooseoptions') ||
           card.querySelector('.product-quickview');
  }

  function productHandle(card) {
    var co = card.querySelector('[data-product-handle]');
    if (co && co.getAttribute('data-product-handle')) return co.getAttribute('data-product-handle');
    return null;
  }
  function productUrl(card) {
    var a = card.querySelector('.card__media a[href], .card__heading a[href], a.full-unstyled-link[href]');
    return a ? a.getAttribute('href') : null;
  }

  /* Decide single vs multi vs sold-out from the theme's own rendered controls. */
  function classify(card) {
    var submit = findAddSubmit(card);
    if (submit) {
      var soldOut = submit.hasAttribute('disabled') || submit.getAttribute('aria-disabled') === 'true';
      return { mode: 'single', soldOut: soldOut };
    }
    if (findChooseOptions(card)) {
      return { mode: 'multi', soldOut: false };
    }
    return null; /* nothing actionable on this card */
  }

  function buildButton(info, url) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vd-cart-btn' + (info.soldOut ? ' vd-soldout' : '');
    btn.setAttribute('data-vd-mode', info.mode);
    if (url) btn.setAttribute('data-vd-url', url);
    if (info.soldOut) {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-label', 'Sold out');
      btn.title = 'Sold out';
    } else if (info.mode === 'single') {
      btn.setAttribute('aria-label', 'Add to cart');
      btn.title = 'Add to cart';
    } else {
      btn.setAttribute('aria-label', 'Choose options');
      btn.title = 'Choose options';
    }
    btn.innerHTML = SVG_CART + SVG_SPIN;
    return btn;
  }

  function decorate(card) {
    if (!card || card.__vdCart) return;
    /* Skip compare/wishlist/quickview product templates if present. */
    var media = card.querySelector('.card__media');
    if (!media) return;
    var info = classify(card);
    if (!info) return;
    card.__vdCart = true;
    card.classList.add('vd-cart-host');
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    media.appendChild(buildButton(info, productUrl(card)));
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) decorate(cards[i]);
  }

  /* ---- Fly-to-cart animation ----
   * The header is NOT sticky on this store, so once the shopper has scrolled
   * down the real cart icon is usually off-screen and a clone flown to it would
   * shoot off the top out of view. To guarantee the shopper ALWAYS sees the
   * product image land somewhere visible, we target the real cart icon ONLY
   * when it is genuinely inside the viewport; otherwise we fly to a fixed
   * on-screen point at the top-right and show a brief "landing" pulse there. */
  function flyTarget() {
    var icon = cartIcon();
    if (icon) {
      var r = icon.getBoundingClientRect();
      var onScreen = r.width > 0 && r.height > 0 &&
                     r.top >= 0 && r.bottom <= window.innerHeight && r.left >= 0;
      if (onScreen) {
        return { x: r.left + r.width / 2, y: r.top + r.height / 2, onIcon: true };
      }
    }
    /* Fixed on-screen fallback: top-right corner, always visible. */
    return { x: window.innerWidth - 34, y: 26, onIcon: false };
  }

  /* Brief pulse at the landing point so the shopper sees the image "land"
     even when the real cart icon is scrolled off-screen. */
  function landingPulse(x, y) {
    try {
      if (!document.getElementById('vd-land-style')) {
        var st = document.createElement('style');
        st.id = 'vd-land-style';
        st.textContent =
          '@keyframes vd-land-pulse{0%{transform:translate(-50%,-50%) scale(.2);opacity:0;}' +
          '35%{transform:translate(-50%,-50%) scale(1.15);opacity:1;}' +
          '70%{transform:translate(-50%,-50%) scale(.92);opacity:1;}' +
          '100%{transform:translate(-50%,-50%) scale(1);opacity:0;}}' +
          '.vd-land-pulse{position:fixed;z-index:2147483601;width:28px;height:28px;border-radius:50%;' +
          'background:var(--vd-cart-bg,#d4e65c);border:2px solid #1f8a4c;' +
          'box-shadow:0 2px 10px rgba(0,0,0,.3);pointer-events:none;' +
          'animation:vd-land-pulse .6s ease forwards;}';
        document.head.appendChild(st);
      }
      var dot = document.createElement('div');
      dot.className = 'vd-land-pulse';
      dot.style.left = x + 'px';
      dot.style.top = y + 'px';
      document.body.appendChild(dot);
      setTimeout(function () { if (dot.parentNode) dot.parentNode.removeChild(dot); }, 650);
    } catch (e) {}
  }

  function flyToCart(card) {
    var tgt = flyTarget();
    var endX = tgt.x;
    var endY = tgt.y;

    if (reduceMotion) { landingPulse(endX, endY); bumpCart(); vdUpdateCounts(); return; }

    var img = card && card.querySelector('.card__media img, .card__media .media img');
    var s = img && img.getBoundingClientRect();
    if (!img || !s || !s.width || !s.height) {
      /* No image to fly — still show the landing pulse + bump. */
      landingPulse(endX, endY); bumpCart(); vdUpdateCounts(); return;
    }

    var clone = img.cloneNode(true);
    clone.className = 'vd-fly-clone';
    clone.removeAttribute('loading');
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    var startSize = Math.min(s.width, s.height, 160);
    clone.style.left = (s.left + (s.width - startSize) / 2) + 'px';
    clone.style.top = (s.top + (s.height - startSize) / 2) + 'px';
    clone.style.width = startSize + 'px';
    clone.style.height = startSize + 'px';
    clone.style.opacity = '1';
    document.body.appendChild(clone);

    clone.getBoundingClientRect();
    requestAnimationFrame(function () {
      clone.style.left = (endX - 13) + 'px';
      clone.style.top = (endY - 13) + 'px';
      clone.style.width = '26px';
      clone.style.height = '26px';
      clone.style.borderRadius = '50%';
      clone.style.opacity = '0.2';
      clone.style.transform = 'rotate(8deg)';
    });
    var done = false;
    function cleanup() {
      if (done) return; done = true;
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      landingPulse(endX, endY);
      bumpCart();
      vdUpdateCounts();
    }
    clone.addEventListener('transitionend', cleanup, { once: true });
    setTimeout(cleanup, 950);
  }
  function bumpCart() {
    var target = cartIcon();
    if (!target) return;
    target.classList.remove('vd-cart-bump');
    void target.offsetWidth;
    target.classList.add('vd-cart-bump');
    setTimeout(function () { target.classList.remove('vd-cart-bump'); }, 500);
  }

  /* ---- Visible header count refresh (theme-independent) ---- */
  function vdUpdateCounts() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c && typeof c.item_count === 'number' ? c.item_count : 0;
        document.querySelectorAll('.cart-count-items, [data-cart-count]').forEach(function (el) {
          el.textContent = n;
        });
        var b = document.getElementById('cart-count-bubble');
        if (b) {
          var num = b.querySelector('span:not(.visually-hidden)') || b;
          if (num) num.textContent = n;
        }
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          el.classList.remove('hidden');
          if (!el.textContent.trim()) el.textContent = n;
        });
      })
      .catch(function () {});
  }

  /* ---- Confirmation toast (self-styled, no theme CSS dependency) ---- */
  var vdToastEl = null;
  var vdToastTimer = null;
  function vdShowToast() {
    if (!vdToastEl) {
      if (!document.getElementById('vd-toast-style')) {
        var st = document.createElement('style');
        st.id = 'vd-toast-style';
        st.textContent =
          '.vd-toast{position:fixed;left:50%;transform:translateX(-50%) translateY(8px);bottom:24px;z-index:99999;' +
          'background:#1c1c1c;color:#fff;padding:12px 18px;border-radius:999px;font-size:14px;line-height:1.2;' +
          'box-shadow:0 4px 16px rgba(0,0,0,.25);display:flex;gap:12px;align-items:center;max-width:calc(100vw - 32px);' +
          'opacity:0;visibility:hidden;pointer-events:none;transition:opacity .25s ease,transform .25s ease;}' +
          '.vd-toast.vd-toast-show{opacity:1;visibility:visible;pointer-events:auto;transform:translateX(-50%) translateY(0);}' +
          '.vd-toast a{color:#9fe0b0;text-decoration:underline;font-size:13px;white-space:nowrap;}' +
          '.vd-toast .vd-toast-check{flex:0 0 auto;}' +
          '@media (max-width:480px){.vd-toast{font-size:13px;padding:10px 14px;gap:10px;bottom:16px;}}';
        document.head.appendChild(st);
      }
      vdToastEl = document.createElement('div');
      vdToastEl.className = 'vd-toast';
      vdToastEl.setAttribute('role', 'status');
      vdToastEl.setAttribute('aria-live', 'polite');
      vdToastEl.innerHTML =
        '<svg class="vd-toast-check" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9fe0b0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
        '<span>Added to cart</span>' +
        '<a href="/cart">View cart</a>';
      document.body.appendChild(vdToastEl);
    }
    /* force reflow so the show transition runs on repeat calls */
    void vdToastEl.offsetWidth;
    vdToastEl.classList.add('vd-toast-show');
    if (vdToastTimer) clearTimeout(vdToastTimer);
    vdToastTimer = setTimeout(function () {
      if (vdToastEl) vdToastEl.classList.remove('vd-toast-show');
    }, 2800);
  }

  function setLoading(btn, on) {
    btn.classList.toggle('vd-loading', !!on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function flashAdded(btn) {
    btn.classList.add('vd-added');
    setTimeout(function () { btn.classList.remove('vd-added'); }, 1100);
  }

  function dispatchAddedEvent() {
    var event;
    if (typeof window.CustomEvent === 'function') {
      event = new CustomEvent('ProductAddtoCart', { bubbles: true });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('ProductAddtoCart', true, false, null);
    }
    document.dispatchEvent(event);
  }

  /* Open / refresh the theme's own cart UI after a successful add. */
  function addSingleVariant(card, variantId, btn) {
    var routesAdd = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(routesAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status && res.data.status >= 400)) {
          throw new Error((res.data && res.data.description) || 'add failed');
        }
        refreshCartBubble();
        try { dispatchAddedEvent(); } catch (e) {}
        return res.data;
      });
  }

  /* Fallback: refresh just the header cart count bubble when no drawer/notif. */
  function refreshCartBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch('/?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#cart-icon-bubble') || doc.querySelector('.shopify-section');
          if (fresh) bubble.innerHTML = fresh.innerHTML;
        } catch (e) {}
      })
      .catch(function () {});
  }

  function openChooseOptions(card, btn) {
    var url = (btn && btn.getAttribute('data-vd-url')) || productUrl(card);
    if (url) { window.location.href = url.split('?')[0]; return; }
    var h = productHandle(card);
    if (h) { window.location.href = '/products/' + h; return; }
  }

  /* =====================================================================
   * SELF-CONTAINED QUICK-ADD POPUP (multi-variant cards)
   * ---------------------------------------------------------------------
   * Universal: works for ANY product type (dokha, cigars, vapes,
   * accessories) because it is driven entirely by the product's own
   * /products/{handle}.js JSON (options + variants). No dependency on the
   * theme's quick-view/modal. Scoped CSS lives under the .vd-qa-* prefix.
   * =================================================================== */
  var vdQa = {
    overlay: null,
    product: null,
    card: null,
    selected: {},   /* { optionName: chosenValue } */
    lastFocus: null,
    keyHandler: null,
    open: false
  };

  /* Money formatting: prefer the theme's Shopify money format if present,
     otherwise fall back to a generic "Dhs. X.XX". Prices in product JS are
     in the shop's minor units (e.g. fils for AED). */
  function vdQaFormatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    var fmt = window.Shopify && window.Shopify.money_format;
    if (fmt && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, fmt); } catch (e) {}
    }
    var n = amount.toFixed(2);
    /* If the theme exposes a currency symbol/format string, try a light
       substitution; otherwise default to the UAE "Dhs." prefix. */
    if (fmt && /\{\{\s*amount\s*\}\}/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount\s*\}\}/, n);
    }
    return 'Dhs. ' + n;
  }

  function vdQaEscape(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Resolve the variant matching the currently chosen option values.
     variant.options is an ordered array aligned to product.options[].name. */
  function vdQaResolveVariant() {
    var p = vdQa.product;
    if (!p || !p.variants) return null;
    var names = (p.options || []).map(function (o) {
      return (typeof o === 'string') ? o : o.name;
    });
    /* Need every option chosen before we can resolve. */
    for (var i = 0; i < names.length; i++) {
      if (vdQa.selected[names[i]] == null) return null;
    }
    for (var v = 0; v < p.variants.length; v++) {
      var variant = p.variants[v];
      var opts = variant.options || [];
      var match = true;
      for (var j = 0; j < names.length; j++) {
        if (String(opts[j]) !== String(vdQa.selected[names[j]])) { match = false; break; }
      }
      if (match) return variant;
    }
    return null;
  }

  /* Whether ANY available variant exists for a given option/value pairing,
     given the OTHER currently-selected options. Used to grey impossible
     combos (kept lightweight — only disables values with no available
     variant at all for that value). */
  function vdQaValueHasStock(optName, value) {
    var p = vdQa.product;
    if (!p || !p.variants) return true;
    var names = (p.options || []).map(function (o) {
      return (typeof o === 'string') ? o : o.name;
    });
    var idx = names.indexOf(optName);
    if (idx < 0) return true;
    for (var v = 0; v < p.variants.length; v++) {
      var variant = p.variants[v];
      if (String((variant.options || [])[idx]) === String(value) && variant.available) {
        return true;
      }
    }
    return false;
  }

  function vdQaUpdateState() {
    if (!vdQa.overlay) return;
    var addBtn = vdQa.overlay.querySelector('.vd-qa-add');
    var priceEl = vdQa.overlay.querySelector('.vd-qa-price');
    var variant = vdQaResolveVariant();

    /* Reflect selected chips. */
    vdQa.overlay.querySelectorAll('.vd-qa-chip').forEach(function (chip) {
      var on = vdQa.selected[chip.getAttribute('data-opt')] === chip.getAttribute('data-val');
      chip.classList.toggle('vd-qa-chip-on', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (variant) {
      if (priceEl) priceEl.textContent = vdQaFormatMoney(variant.price);
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.classList.remove('vd-qa-add-disabled');
        addBtn.textContent = 'Add to cart';
      } else {
        addBtn.disabled = true;
        addBtn.classList.add('vd-qa-add-disabled');
        addBtn.textContent = 'Sold out';
      }
    } else {
      addBtn.disabled = true;
      addBtn.classList.add('vd-qa-add-disabled');
      addBtn.textContent = 'Add to cart';
    }
  }

  function vdQaClose() {
    if (!vdQa.open) return;
    vdQa.open = false;
    if (vdQa.keyHandler) {
      document.removeEventListener('keydown', vdQa.keyHandler, true);
      vdQa.keyHandler = null;
    }
    if (vdQa.overlay && vdQa.overlay.parentNode) {
      vdQa.overlay.parentNode.removeChild(vdQa.overlay);
    }
    vdQa.overlay = null;
    vdQa.product = null;
    vdQa.selected = {};
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (vdQa.lastFocus && typeof vdQa.lastFocus.focus === 'function') {
      try { vdQa.lastFocus.focus(); } catch (e) {}
    }
    vdQa.lastFocus = null;
  }

  function vdQaBuild(product, card, btn) {
    var overlay = document.createElement('div');
    overlay.className = 'vd-qa-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Choose options for ' + (product.title || 'product'));

    var img = product.featured_image || (product.images && product.images[0]) || '';
    var handle = product.handle || productHandle(card);
    var fullUrl = (btn && btn.getAttribute('data-vd-url')) || productUrl(card) ||
                  (handle ? '/products/' + handle : '#');
    fullUrl = String(fullUrl).split('?')[0];

    var optionsHtml = '';
    var names = (product.options || []).map(function (o) {
      return (typeof o === 'string') ? o : o.name;
    });
    var values = (product.options || []).map(function (o) {
      return (typeof o === 'string') ? [] : (o.values || []);
    });

    for (var oi = 0; oi < names.length; oi++) {
      var nm = names[oi];
      var vals = values[oi] || [];
      var chips = '';
      for (var vi = 0; vi < vals.length; vi++) {
        var val = vals[vi];
        var noStock = !vdQaValueHasStock(nm, val);
        chips +=
          '<button type="button" class="vd-qa-chip' + (noStock ? ' vd-qa-chip-oos' : '') + '" ' +
          'data-opt="' + vdQaEscape(nm) + '" data-val="' + vdQaEscape(val) + '" ' +
          'aria-pressed="false"' + (noStock ? ' aria-disabled="true"' : '') + '>' +
          vdQaEscape(val) + '</button>';
      }
      optionsHtml +=
        '<div class="vd-qa-optrow">' +
        '<div class="vd-qa-optlabel">' + vdQaEscape(nm) + '</div>' +
        '<div class="vd-qa-chips">' + chips + '</div>' +
        '</div>';
    }

    var fromPrice = vdQaFormatMoney(
      typeof product.price_min === 'number' ? product.price_min : product.price
    );

    overlay.innerHTML =
      '<div class="vd-qa-card" role="document">' +
        '<button type="button" class="vd-qa-close" aria-label="Close">&times;</button>' +
        '<div class="vd-qa-head">' +
          (img ? '<img class="vd-qa-img" src="' + vdQaEscape(img) + '" alt="" loading="lazy">' : '') +
          '<div class="vd-qa-headtext">' +
            '<div class="vd-qa-title">' + vdQaEscape(product.title) + '</div>' +
            '<div class="vd-qa-price">' + fromPrice + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="vd-qa-options">' + optionsHtml + '</div>' +
        '<div class="vd-qa-msg" role="alert" aria-live="assertive"></div>' +
        '<button type="button" class="vd-qa-add vd-qa-add-disabled" disabled>Add to cart</button>' +
        '<a class="vd-qa-details" href="' + vdQaEscape(fullUrl) + '">View full details &rarr;</a>' +
      '</div>';

    return overlay;
  }

  function openQuickAdd(card, btn) {
    if (vdQa.open) return;
    var handle = productHandle(card);
    if (!handle) {
      var u = (btn && btn.getAttribute('data-vd-url')) || productUrl(card);
      /* Handle = last path segment of the product URL. */
      if (u) {
        var parts = String(u).split('?')[0].split('/');
        handle = parts[parts.length - 1] || parts[parts.length - 2];
      }
    }
    if (!handle) { openChooseOptions(card, btn); return; }

    setLoading(btn, true);
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.json();
      })
      .then(function (product) {
        setLoading(btn, false);
        vdQaShow(product, card, btn);
      })
      .catch(function () {
        setLoading(btn, false);
        /* Fallback: navigate to the product page so the shopper isn't stuck. */
        openChooseOptions(card, btn);
      });
  }

  function vdQaShow(product, card, btn) {
    vdQa.product = product;
    vdQa.card = card;
    vdQa.selected = {};
    vdQa.open = true;
    vdQa.lastFocus = document.activeElement;

    var overlay = vdQaBuild(product, card, btn);
    vdQa.overlay = overlay;
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    /* If a product has only ONE option, default-select its first AVAILABLE
       value so it's a one-tap add. */
    var names = (product.options || []).map(function (o) {
      return (typeof o === 'string') ? o : o.name;
    });
    if (names.length === 1) {
      var only = product.options[0];
      var vals = (typeof only === 'string') ? [] : (only.values || []);
      for (var i = 0; i < vals.length; i++) {
        if (vdQaValueHasStock(names[0], vals[i])) {
          vdQa.selected[names[0]] = vals[i];
          break;
        }
      }
    }

    /* Chip selection (delegated within the overlay). */
    overlay.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('.vd-qa-chip');
      if (chip) {
        var opt = chip.getAttribute('data-opt');
        var val = chip.getAttribute('data-val');
        vdQa.selected[opt] = val;
        vdQaUpdateState();
        return;
      }
      if (e.target.closest && e.target.closest('.vd-qa-close')) { vdQaClose(); return; }
      if (e.target.closest && e.target.closest('.vd-qa-add')) { vdQaSubmit(card, btn); return; }
      /* Overlay (outside the card) click closes. */
      if (e.target === overlay) { vdQaClose(); return; }
    });

    /* Escape + minimal focus trap. */
    vdQa.keyHandler = function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); vdQaClose(); return; }
      if (e.key === 'Tab') {
        var focusables = overlay.querySelectorAll(
          '.vd-qa-close, .vd-qa-chip, .vd-qa-add:not([disabled]), .vd-qa-details'
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    };
    document.addEventListener('keydown', vdQa.keyHandler, true);

    vdQaUpdateState();

    /* Focus the first chip on open (minimal focus trap entry point). */
    var firstChip = overlay.querySelector('.vd-qa-chip') || overlay.querySelector('.vd-qa-close');
    if (firstChip) { try { firstChip.focus(); } catch (e) {} }
  }

  function vdQaSubmit(card, btn) {
    var variant = vdQaResolveVariant();
    var msg = vdQa.overlay && vdQa.overlay.querySelector('.vd-qa-msg');
    if (!variant || !variant.available) {
      if (msg) msg.textContent = 'Please choose an available option.';
      return;
    }
    var addBtn = vdQa.overlay.querySelector('.vd-qa-add');
    if (addBtn) { addBtn.disabled = true; addBtn.classList.add('vd-qa-loading'); addBtn.textContent = 'Adding…'; }
    if (msg) msg.textContent = '';

    var routesAdd = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(routesAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status && res.data.status >= 400)) {
          throw new Error((res.data && res.data.description) || 'add failed');
        }
        refreshCartBubble();
        try { dispatchAddedEvent(); } catch (e) {}
        /* Close popup, then run the SAME success UX as single-variant adds:
           fly-to-cart from the originating card, count refresh, toast. */
        var theCard = card;
        vdQaClose();
        flyToCart(theCard);
        vdUpdateCounts();
        vdShowToast();
      })
      .catch(function () {
        if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('vd-qa-loading'); addBtn.textContent = 'Add to cart'; }
        if (msg) msg.textContent = 'Sorry, that could not be added. Please try again.';
      });
  }

  function handleClick(btn) {
    if (btn.hasAttribute('disabled') || btn.classList.contains('vd-soldout')) return;
    if (btn.classList.contains('vd-loading')) return;
    var card = btn.closest('.card-wrapper') || btn.closest('.card');
    if (!card) return;
    var mode = btn.getAttribute('data-vd-mode');

    if (mode !== 'single') {
      openQuickAdd(card, btn);
      return;
    }

    var variantId = findVariantId(card);
    if (!variantId) {
      var u = btn.getAttribute('data-vd-url');
      if (u) window.location.href = u;
      return;
    }

    setLoading(btn, true);
    flyToCart(card);

    addSingleVariant(card, variantId, btn)
      .then(function () {
        setLoading(btn, false);
        flashAdded(btn);
        vdUpdateCounts();
        vdShowToast();
      })
      .catch(function () {
        setLoading(btn, false);
        var u2 = btn.getAttribute('data-vd-url');
        if (u2) window.location.href = u2;
      });
  }

  /* Delegated activation (works for AJAX-injected cards too). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.vd-cart-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleClick(btn);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var btn = e.target.closest && e.target.closest('.vd-cart-btn');
    if (!btn) return;
    e.preventDefault();
    handleClick(btn);
  });

  /* Initial scan + observe for AJAX-injected cards. */
  function init() { scan(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function () { setTimeout(init, 600); });

  try {
    var target = document.getElementById('MainContent') || document.body;
    var debounce, mo = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { scan(document); }, 250);
    });
    mo.observe(target, { childList: true, subtree: true });
  } catch (e) {}
})();
